<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre7" id="lost-farm-camp"><div class="level" id="chapter-iiimuch-ado-about-beelzebub">
<span id="much-ado-about-beelzebub"></span><h2 class="level1" id="pgepubid00002"><span class="calibre13">CHAPTER III<br class="calibre12"/>MUCH ADO ABOUT BEELZEBUB</span></h2>
<p class="align-center2"><span>Fourteen of the fifteen men, who arrived
at Avery’s camp that afternoon, came
into the woods because they had to. The
fifteenth, David Ross, came because he wanted
to. Ever since he could read he had dreamed of
going into the woods and living with the lumbermen
and trappers. His aunt and only living relative,
Elizabeth Ross, had discouraged him from
leaving the many opportunities made possible by
her generosity. She had adopted the boy when
his father died, and she had provided for him
liberally. When he came of age the modest income
which his father’s estate provided was
transferred from her care, as a trustee, to him.
Then she had offered him his choice of professions,
with the understanding that her considerable
fortune was to be his at her death. She had
hoped to have him with her indefinitely, but his
determination to see more of the woods than his
summer vacations allowed finally resolved itself
into action. He told her one evening that he had
“signed up” with the Great Western Lumber
Company.</span></p>
<p class="calibre14"><span>Protests, supplications, arguments were of no
avail. He had listened quietly and even smilingly
as his aunt pointed out what seemed to her to be
the absurdities of the plan. Even a suggested
tour of the Continent failed to move him. Finally
she made a last appeal.</span></p>
<p class="calibre14"><span>“If your income isn’t sufficient, Davy, I’ll—”</span></p>
<p class="calibre14"><span>He interrupted her with a gesture. “I’ve always
had enough money,” he replied. “It isn’t
that.”</span></p>
<p class="calibre14"><span>“You’re just like your father, David,” she
said. “I suppose I shall have to let you go, but
remember there is some one else who will miss
you.”</span></p>
<p class="calibre14"><span>“Miss Bascomb has assured me that we can
never agree, on—on certain things, so there is
really nothing to keep me here,—except you,”
he added in a gentler tone, as he saw the pained
look on her kindly old face. “And you just said
you would let me go.”</span></p>
<p class="calibre14"><span>“Would have to let you go, Davy.”</span></p>
<p class="calibre14"><span>“Well, it’s all the same, isn’t it, Aunt Bess?”</span></p>
<p class="calibre14"><span>She smiled tearfully at his boyishness. “It
seems to be,” she replied. “I am sorry about
Bessie—”</span></p>
<p class="calibre14"><span>The following morning he had appeared at an
employment office where “Fisty” Harrigan of
the Great Western had “taken him on” as a
likely hand, influenced by his level gaze and direct
manner. “Fisty” and David Ross promised
to become good friends until, during their stay at
the last hotel en route to the lumber camp, Harrigan
had suggested “a little game wid th’ b’ys,”
wherein the “b’ys” were to be relieved of their
surplus change.</span></p>
<p class="calibre14"><span>“They jest t’row it away anyhow,” he continued,
as David’s friendly chat changed to a frigid
silence. “T’ought you was a sport,” said Harrigan,
with an attempt at jocularity.</span></p>
<p class="calibre14"><span>“That’s just why I don’t play poker with that
kind,” replied David, gesturing contemptuously
toward the mellow fourteen strung in loose-jointed
attitudes along the hotel bar. “I like
sport, but I like it straight from the shoulder.”</span></p>
<p class="calibre14"><span>“You do, hey?” snarled Harrigan, drawing
back a clenched fist. Ross looked him full in the
eye, calm and unafraid. Fisty’s arm dropped to
his side. He tried a new tack. “I was only tryin’
you out, kid, and you’re all right, all right,” he
said with oily familiarity.</span></p>
<p class="calibre14"><span>“Sorry I can’t say the same for you, Harrigan,”
replied David. “But I’m going through to
the camps. That’s what I came in for. If I don’t
go with this crew, I’ll go with another.”</span></p>
<p class="calibre14"><span>“Forget it and come and have a drink,” said
Fisty, trying to hide his anger beneath an assumption
of hospitality. He determined to be even with
Ross when he had him in camp and practically at
his mercy. David declined both propositions and
Harrigan moved away muttering.</span></p>
<p class="calibre14"><span>So it happened that when they arrived at Lost
Farm Camp, the last stopping-place until they
reached the winter operations of the Company
at Nine-Fifteen, Fisty and David were on anything
but friendly terms. David’s taciturn aloofness
irritated Harrigan, who was not used to having
men he hired cross his suggestions or disdain
his companionship. When they arose in the morning
to Avery’s “Whoo—Halloo” for breakfast,
Harrigan was in an unusually sour mood and
David’s cheerful “good-morning” aggravated
him.</span></p>
<p class="calibre14"><span>The men felt that there was something wrong
between the “boss” and the “green guy,” as they
termed David, and breakfast progressed silently.
A straw precipitated the impending quarrel.</span></p>
<p class="calibre14"><span>The kitten Beelzebub, prowling round the table
and rubbing against the men’s legs, jumped playfully
to Harrigan’s shoulder. Harrigan reached
back for him, but the kitten clung to his perch,
digging in manfully to hang on. The men laughed
uproariously. Fisty, enraged, grabbed the astonished
kitten and flung it against the wall. “What’n
hell kind of a dump is this—” he began; but
Swickey’s rush for her pet and the wail she gave
as Beelzebub, limp and silent, refused to move,
interrupted him.</span></p>
<p class="calibre14"><span>Avery turned from the stove and strode toward
Harrigan, undoing his long white cook’s apron as
he came, but Ross was on his feet and in front of
the Irishman in a bound.</span></p>
<p class="calibre14"><span>“You whelp!” he said, shaking his fist under
Harrigan’s nose.</span></p>
<p class="calibre14"><span>The men arose, dropping knives and forks in
their amazement.</span></p>
<p class="calibre14"><span>Fisty sat dazed for a moment; then his face
grew purple.</span></p>
<p class="calibre14"><span>“You little skunk, I’ll kill you fur this!”</span></p>
<p class="calibre14"><span>Avery interfered. “If thar’s goin’ to be any
killin’ did, promisc’us-like, I reckon it’ll be did
out thar,” he said quietly, pointing toward the
doorway. “I ain’t calc’latin’ to have things
mussed up in here, fur I tend to my own house-cleanin’,
understand?”</span></p>
<p class="calibre14"><span>Ross, who anticipated a “free-for-all,” stood
with a chair swung halfway to his shoulder. At
Avery’s word, however, he dropped it.</span></p>
<p class="calibre14"><span>“Sorry, Avery, but I’m not used to that kind
of thing,” he said, pointing to Harrigan.</span></p>
<p class="calibre14"><span>“Like ’nough, like ’nough—I hain’t nuther,”
replied Avery conciliatingly. “But don’t you git
your dander up any wuss than it be, fur I reckon
you got your work cut out keepin’ yourself persentable
fur a spell.” He drew Ross to one side.
“Fisty ain’t called ‘Fisty’ fur nothin’, but I’ll
see to the rest of ’em.”</span></p>
<p class="calibre14"><span>Harrigan, cursing volubly, went outside, followed
by the men. Avery paused to offer a word
of advice to Ross.</span></p>
<p class="calibre14"><span>“He’s a drinkin’ man, and you ain’t, I take it.
Wal, lay fur his wind,” he whispered. “Never
mind his face. Let him think he’s got you all
bruk up ’n’ then let him have it in the stummick,
but watch out he don’t use his boots on you.”</span></p>
<p class="calibre14"><span>Harrigan, blazing with rage, flung his coat
from him as Ross came up. The men drew back,
whispering as Ross took off his coat, folded it
and handed it to Avery. The young man’s cool
deliberation impressed them.</span></p>
<p class="calibre14"><span>Harrigan rushed at Ross, who dropped quickly
to one knee as the Irishman’s flail-like swing
whistled over his head. Before Harrigan could
recover his poise, Ross shot up and drove a clean,
straight blow to Harrigan’s stomach. The Irishman
grunted and one of the men laughed. He
drew back and came on again, both arms going.
Ross circled his opponent, avoiding the slow,
heavy blows easily.</span></p>
<p class="calibre14"><span>“Damn you!” panted Harrigan, “stand up and
take your dose—”</span></p>
<p class="calibre14"><span>Ross lashed a quick stinging fist to the other’s
face, and jumped back as Harrigan, head down,
swung a blow that would have annihilated an ox,
had it landed, but David leaped back, and as Harrigan
staggered from the force of his own blow, he
leaped in again. There was a flash and a thud.</span></p>
<p class="calibre14"><span>The Irishman wiped the blood from his lips,
and shaking his head, charged at Ross as though
he would bear him down by sheer weight. Contrary
to the expectations of the excited woodsmen,
Ross, stooping a little, ran at Harrigan and
they met with a sickening crash of blows that
made the onlookers groan. Ross staggered away
from his opponent, his left arm hanging nervelessly
at his side. As Harrigan recovered breath
and lunged at him again, Ross circled away rubbing
his shoulder.</span></p>
<p class="calibre14"><span>Harrigan’s swollen lips grinned hideously.
“Now, you pup—”</span></p>
<p class="calibre14"><span>He swung his right arm, and as he did so Avery
shouted, “Watch out fur his boots!”</span></p>
<p class="calibre14"><span>David’s apparently useless left arm shot down
as Harrigan drew up his knee and drove his boot
at the other’s abdomen. Ross caught Harrigan’s
ankle and jerked it toward him. The Irishman
crashed to the ground and lay still.</span></p>
<p class="calibre14"><span>With a deliberation that held the men breathless,
Ross strode to the fallen man and stood over
him. Harrigan got to his knees.</span></p>
<p class="calibre14"><span>“Come on, get up!” said Ross.</span></p>
<p class="calibre14"><span>Harrigan, looking at the white face and gleaming
eyes above him, realized that his prestige as
a “scrapper” was gone. He thrust out his hand
and pushed Ross from him, staggering to his
feet. As the trout leaps, so David’s fist shot up
and smashed to Harrigan’s chin. The Irishman
staggered, his arms groping aimlessly.</span></p>
<p class="calibre14"><span>“Get him! Get him!” shouted Avery.</span></p>
<p class="calibre14"><span>Ross took one step forward and swung a blow
to Harrigan’s stomach. With the groan of a
wounded bull, the Irishman wilted to a gasping
bulk of twitching arms and legs.</span></p>
<p class="calibre14"><span>For a moment the men stood spellbound. Fisty
Harrigan, the bulldog of the Great Western, had
been whipped by a “green guy”—a city man.
They moved toward the prostrate Fisty, looking
at him curiously. Ross walked to the chopping-log
in the dooryard, and sat down.</span></p>
<p class="calibre14"><span>“Thought he bruk your arm,” said Avery,
coming toward him.</span></p>
<p class="calibre14"><span>“Never touched it,” replied Ross. “Much
obliged for the pointer. He nearly had me, though,
that time when we mixed it up.”</span></p>
<p class="calibre14"><span>One of the men brought water and threw it on
Harrigan, who finally got to his feet. Ross
jumped from the log and ran to him.</span></p>
<p class="calibre14"><span>“All right, Harrigan,” he said. “I’m ready to
finish the job.”</span></p>
<p class="calibre14"><span>Harrigan raised a shaking arm and motioned
him away.</span></p>
<p class="calibre14"><span>Ross stepped back and drew his sleeve across
his sweating face.</span></p>
<p class="calibre14"><span>“He’s got his’n,” said Avery. “Didn’t reckon
you could do the job, but good men’s like good
hosses, you can’t tell ’em until you try ’em out.
Wal, you saved me a piece of work, and I thank
ye.”</span></p>
<p class="calibre14"><span>A bully always knows when he is whipped.
Fisty was no exception to the rule. He refused
Ross’s hand when he had recovered enough
breath to refuse anything. Ross laughed easily,
and Harrigan turned on him with a curse. “The
Great Western’s t’rough wid you, but I ain’t—yet.”</span></p>
<p class="calibre14"><span>“Well, you want to train for it,” said Ross,
pleasantly.</span></p>
<p class="calibre14"><span>One by one the men shouldered their packs
and jogged down the trail, bound for Nine-Fifteen,
followed by Harrigan, his usually red face
mottled with white blotches and murder in his
agate-blue eyes.</span></p>
<p class="calibre14"><span>David stood watching them.</span></p>
<p class="calibre14"><span>“So-long, boys,” he called.</span></p>
<p class="calibre14"><span>“So-long, kid,” they answered.</span></p>
<p class="calibre14"><span>Harrigan’s quarrel was none of theirs and his
reputation as a bruiser had suffered immeasurably.
In a moment they were lost to sight in the
shadow of the pines bordering the trail.</span></p>
<p class="calibre14"><span>“Now for the kitten,” said David. “I think
he’s only stunned.” He went into the cabin, and
much to Avery’s amusement, washed his hands.
“A dirty job,” he said, catching the twinkle in
the lumberman’s eye.</span></p>
<p class="calibre14"><span>“A dum’ good job, I take it. Whar you from?”</span></p>
<p class="calibre14"><span>“Boston.”</span></p>
<p class="calibre14"><span>“Wal, I seen some mighty queer folks as hailed
from Boston, but I don’t recollec’ any jest like
you.”</span></p>
<p class="calibre14"><span>David laughed as he went to the corner and
stooped over Swickey, who sat tearfully rocking
the limp Beelzebub in her dress.</span></p>
<p class="calibre14"><span>“What’s his name?” he asked gently.</span></p>
<p class="calibre14"><span>“Be—el—zebub,” she sobbed.</span></p>
<p class="calibre14"><span>“Will you let me look at him—just a minute?”</span></p>
<p class="calibre14"><span>Swickey unrolled her skirt, the kitten tumbled
from her knees, turned over, arched his back, and
with tail perpendicular shot across the cabin floor
and through the doorway as though nothing had
happened.</span></p>
<p class="calibre14"><span>David laughed boyishly.</span></p>
<p class="calibre14"><span>“He’s got eight of them left, even now.”</span></p>
<p class="calibre14"><span>“Eight whats left?” queried Swickey, fixing
two tearfully wondering eyes on his face.</span></p>
<p class="calibre14"><span>“Eight lives, you know. Every cat has nine
lives.”</span></p>
<p class="calibre14"><span>Swickey took his word for it without question,
possibly because “eight” and “nine” suggested
the intricacies of arithmetic. Although little more
than a healthy young animal herself, she had
instinctively disliked and mistrusted most of the
men who came to Lost Farm Camp. But this man
was different. He seemed more like her father,
in the way he looked at her, and yet he was quite
unlike him too.</span></p>
<p class="calibre14"><span>“That’s a big name for such a little cat,” said
David. “Where did he get his name?”</span></p>
<p class="calibre14"><span>Swickey pondered. “Pop says it’s his name,
and I guess Pop knows. The ole cat she run wild
in the woods and took Beelzebub ’long with her
’fore he growed up, and Pop ketched him, and
he bit Pop’s thumb, and then Pop said thet was
his name. He ketched him fur me.”</span></p>
<p class="calibre14"><span>Just then Avery came in with a pail of water
and Swickey set about clearing the table. David,
a bit shaken despite his apparently easy manner,
strolled out into the sunshine and down the hill
to the river. “My chance with the Great Western
is gone,” he muttered, “and all on account of a
confounded little cat, and called ‘Beelzebub’ at
that! Harrigan would fix me now if I went in,
that’s certain. Accidents happen in the camps
and the victims come out, feet first, or don’t come
out at all and no questions asked. No, I’ll have
to look for something else. Hang it!” he exclaimed,
rubbing his arm, “this being squire of
dames and kittens don’t pay.”</span></p>
<p class="calibre14"><span>Unconsciously he followed the trail down to
the dam, across the gorge, and on up the opposite
slope. The second-growth maple, birch, and poplar
gave place to heavy beech, spruce, and pine
as he went on. Presently he was in the thick
of a regiment of great spruce trees that stood
rigidly at “attention.” The shadows deepened
and the small noises of the riverside died away.
A turn in the trail and a startled doe faced him,
slender-legged, tense with surprise, wide ears
pointed forward and nostrils working.</span></p>
<p class="calibre14"><span>He stopped. The deer, instead of snorting and
bounding away, moved deliberately across the
trail and into a screen of undergrowth opposite
him. David stood motionless. Then from the
bushes came a little fawn, timidly, lifting its front
feet with quick, jerky motions, but placing them
with the instinctive caution of the wild kindred.
Scarcely had the fawn appeared when another,
smaller and dappled beautifully, followed. Their
motions were mechanical, muscles set, as if ready
to leap to a wild run in a second.</span></p>
<p class="calibre14"><span>What unheard, unseen signal the doe gave to
her offspring, David never knew, but, as though
they had received a terse command, the two fawns
wheeled suddenly and bounded up the trail, at
the top of which the doe was standing. Three white
flags bobbed over the crest and they were gone.</span></p>
<p class="calibre14"><span>“How on earth did that doe circle to the hillside
without my seeing her?” he thought. Then
he laughed as he remembered the stiff-legged
antics of the fawns as they bounded away, stirring
a noisy squirrel to rebuke. On he went, over
the crest and down a gentle slope, past giant
beeches and yellow birch whose python-like roots
crept over the moss and disappeared as though
slowly writhing from the sunlight to subterranean
fastnesses. Dwarfed and distorted cedars sprung
up along the way and he knew he was near water.
In a few minutes he stood on the shore of No-Man’s
Lake, whose unruffled surface reflected the
broad shadow of Timberland Mountain on the
opposite shore.</span></p>
<p class="calibre14"><span>“Well!” he exclaimed, “I suppose it’s time
to corral a legion of guide-book adjectives and
launch ’em at yonder mass of silver and green
glories, but it’s all too big. It calls for silence. A
fellow doesn’t gush in a cathedral, unless he
doesn’t belong there.” He sat looking over the
water for perhaps an hour, contented in the restful
vista around him. “I wish Aunt Elizabeth
could see this,” he muttered finally. “Then she
might understand why I like it. Wonder who
owns that strip of land opposite? I’d like to. Great
Scott! but my arm’s sore where he poked me.”</span></p>
<p class="calibre14"><span>A soft tread startled him. He swung round to
find Hoss Avery, shod with silent moosehide, a
Winchester across his arm, standing a few feet
away.</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?09be5992